export enum OfferStatus {
  notFilled = 'notFilled',
  partiallyFilled = 'partiallyFilled',
  completed = 'completed',
  cancelled = 'cancelled',
  expired = 'expired',
}
